// extracted by mini-css-extract-plugin
export default {"overlay":"tu-z","bodyOpen":"uu-z","content":"vu-z","header":"wu-z","close":"xu-z","closeNoHeading":"yu-z"};